<div class="setup-wrapper">
    <img class="logo" src="../../../assets/svg/FieldEx_Logo_Black_NoBorder.svg" alt="FieldEx Logo" />

    <div class="setup-left">
        <div class="module-wrapper">
            <h2>Customize your workspace</h2>
            <p class="subtitle">
                Choose the modules your team will use. The rest will be hidden to keep things clean, but can be add back at any time.
            </p>
            <div class="module-grid">
                <div *ngFor="let module of moduleSetupFeatureData;index as i" class="module-card" [class.active]="isSelected(module.key)" (click)="toggleModule(module,i)" 
                [style.opacity]="module.available ? 1 : 0.3">

                    <img [src]="module.icon" alt="{{ module.label }}" />
                    <div class="module-text">
                        <h4>
                            {{ module.label }}
                            <i *ngIf="!module.available" class="fa-solid fa-crown crown-icon-inline"></i>
                        </h4>
                        <p *ngIf="module.desc">{{ module.desc }}</p>
                    </div>

                    <div class="checkbox-wrap" [ngClass]="{'checked': module.available && module.enabled ? module.enabled:false}">
                        <span class="check" *ngIf="isSelected(module.key)">
                            <i class="fa-solid fa-check"></i>
                        </span>
                    </div>
                </div>
            </div>

           <div class="upgrade-info" *ngIf="packageCode == 'Lite' || packageCode == 'Growth'">
                <div class="upgrade-text">
                    <i class="fa-regular fa-circle-info"></i>
                    <span>
                    Modules marked with
                    <i class="fa-solid fa-crown"></i>
                    require a FieldEx Pro license or higher. To access these modules, upgrade your plan in "Setup > Licenses & Billings" within the app.
                    </span>
                </div>
                <!-- <a href="#" class="upgrade-link">
                    <i class="fa-solid fa-crown"></i>
                    Upgrade
                </a> -->
            </div>

            <div class="button-row-outline">
                <button type="button" class="btn-back" (click)="goToPrevious()">Back</button>
                <button type="button" class="btn-next" [disabled]="submitTouched" (click)="onSubmitForm()">Finish</button>
            </div>

        </div>


        <!-- Optional: Step progress indicator -->
        <div class="step-indicator">
            <div class="steps">
                <span
                class="dot"
                *ngFor="let n of [1, 2, 3]"
                [class.active]="n <= currentStep"
                [@dotAnim]="n === currentStep ? 'active' : 'inactive'">
                </span>
            </div>
            <span class="step-label">Step {{ currentStep }}/3</span>
        </div>
    </div>

    <div class="setup-right">
        <div class="ui-preview">
            <div class="preview-shell-zoomed">
                <aside class="preview-sidebar">
                    <div class="preview-logo">
                        <img src="../../../assets/svg/FieldEx_Logo_White_NoBorder.svg" class="header-logo">
                    </div>
                    <ul class="preview-nav" *ngIf="selectedModules && moduleSetupFeatureData.length > 0">
                        <li *ngFor="let mod of selectedModules">
                                <div class="icon-wrap">
                                    <img class="icon-logo" [src]="mod.iconMenu" [ngClass]="{'checklist': mod.key === 'checklists'}"/>
                                </div>
                                <span>{{ mod.label }}</span>
                           

                        </li>
                    </ul>
                    <div class="preview-footer">
                        <i class="fa-regular fa-gear"></i>
                        <i class="fa-regular fa-book-open"></i>
                    </div>
                </aside>

                <main class="preview-main">
                    <header class="preview-header">
                        {{companyName}}
                    </header>
                    <section class="preview-content">
                        <!-- Empty grey content space -->
                    </section>
                </main>
            </div>

        </div>
    </div>
</div>